/**
 * Vision 2040 Translations Module (Spanish)
 * @module vision2040
 * @language es
 */

export const vision2040 = {
  vision2040Hero: {
    membersTarget: "Meta de Miembros",
    countryTarget: "Meta de Países",
    annualBeneficiaries: "Beneficiarios Anuales"
  },
  vision2040TechTargets: {
    aiUsers: "400K+ usuarios",
    vrTrainers: "10K+ entrenadores",
    appDownloads: "300K+ descargas",
    sustainabilityCountries: "80 países"
  },
  strategicPillarsData: {
    expandTraining: "Expandir Programas de Capacitación en Liderazgo",
    certifiedTrainers: "10.000 Entrenadores Certificados",
    goldStandard: "Currículo Estándar de Oro",
    trainingTarget: "100K capacitados anualmente para 2040",
    expandDetail1: "Escalar JCI Academy a 130+ países",
    expandDetail2: "Desarrollar 10K entrenadores certificados globalmente",
    expandDetail3: "Lanzar plataforma de capacitación multilingüe",
    expandDetail4: "Crear trayectorias de liderazgo específicas por industria",
    expandDetail5: "Establecer asociaciones con universidades",
    trainedYear: "Capacitados/Año",
    aiDashboard: "Panel con IA",
    offlineApp: "App Móvil Offline-First",
    impactTracking: "Seguimiento de Impacto en Tiempo Real",
    techTarget: "80% de adopción digital para 2040",
    techDetail1: "Implementar plataforma de experiencia del miembro con IA",
    techDetail2: "Lanzar programa de simulación de liderazgo VR",
    techDetail3: "Crear panel de datos global unificado",
    techDetail4: "Implementar verificación de impacto blockchain",
    techDetail5: "Construir plataforma mobile-first accesible",
    users: "Usuarios",
    climateAction: "Integración de Acción Climática",
    carbonNeutral: "Operaciones Carbon Neutral",
    renewableEnergy: "100% Energía Renovable",
    sustainabilityTarget: "Net-zero para 2030",
    sustainDetail1: "Alcanzar operaciones carbon neutral para 2030",
    sustainDetail2: "Integrar mapeo ODS para todos los proyectos",
    sustainDetail3: "Crear programa de certificación verde",
    sustainDetail4: "Asociarse con organizaciones ambientales",
    sustainDetail5: "Desarrollar currículo de alfabetización climática",
    riseProjects: "Proyectos RISE",
    genderParity: "Logro de Paridad de Género",
    expandUnderrepresented: "Expandir a Regiones Subrepresentadas",
    financialAccess: "Programas de Acceso Financiero",
    equityTarget: "50% paridad de género para 2035",
    equityDetail1: "Alcanzar 50% paridad de género en liderazgo",
    equityDetail2: "Expandir presencia en regiones desatendidas",
    equityDetail3: "Crear programas de becas para acceso",
    equityDetail4: "Desarrollar marcos de liderazgo inclusivos",
    equityDetail5: "Construir infraestructura de accesibilidad"
  },
  simulator: {
    factors: {
      conservativeGrowth: "Crecimiento anual de 2-3% de miembros",
      limitedDigital: "Adopción limitada de plataforma digital",
      minimalPartnerships: "Mínimas nuevas asociaciones corporativas",
      regionalChallenges: "Desafíos de expansión regional",
      moderateGrowth: "Crecimiento anual de 5-7% de miembros",
      fullDigital: "Implementación completa de plataforma digital",
      strategicPartnerships: "Asociaciones corporativas estratégicas",
      regionalExpansion: "Expansión regional coordinada",
      aggressiveGrowth: "Crecimiento anual de 10-15% de miembros",
      aiEngagement: "Engagement de miembros con IA",
      youthMovement: "Expansión viral del movimiento juvenil",
      corporateSponsors: "Grandes patrocinadores corporativos"
    },
    risks: {
      targetsMissed: "Las metas de Visión 2040 pueden no alcanzarse",
      reducedInfluence: "Influencia y alcance global reducidos",
      talentGaps: "Brechas de talento en regiones desatendidas",
      sustainedInvestment: "Inversión sostenida necesaria",
      techInfrastructure: "Infraestructura tecnológica requerida",
      regionalLeadership: "Liderazgo regional fuerte necesario",
      strainResources: "Los recursos pueden sobrecargarse",
      qualityQuantity: "Equilibrio calidad vs cantidad",
      governanceChallenges: "Desafíos de gobernanza"
    }
  },
  vision2040: {
    title: "JCI Visión 2040",
    pageSubtitle: "Hoja de Ruta Estratégica hacia 500.000 Jóvenes Líderes",
    transformingFuture: "Transformando el Futuro del Liderazgo Joven",
    followProgress: "Siga nuestro progreso hacia una red global de 500.000 jóvenes líderes creando impacto positivo sostenible para 2040.",
    exploreVision: "Explorar Visión 2040",
    
    // Tab Labels
    fiiImpact: "Impacto FII",
    timeline: "Línea de Tiempo",
    simulator: "Simulador",
    globalView: "Visión Global",
    
    // FII Impact Section
    fiiImpactTitle: "Impacto FII para 2040",
    fiiImpactDesc: "Mejoras proyectadas del Índice de Inversión Futura si JCI ejecuta la estrategia Visión 2040",
    globalFIIPoints: "Puntos FII Globales",
    africaMeFII: "Puntos FII África/MO",
    inequalityReduction: "Reducción de Desigualdad",
    regionalGapClosure: "Cierre de brecha regional",
    highest: "más alto",
    mentalHealthPillar: "Salud Mental",
    workforceDevelopment: "Desarrollo de Fuerza Laboral",
    entrepreneurshipPillar: "Emprendimiento",
    projectedReach: "Alcance Proyectado",
    fiiImpactLabel: "Impacto FII",
    primaryFocus: "Enfoque primario",
    regionalFIIProjectionsTitle: "Proyecciones FII Regionales: 2025 vs 2040",
    current2025: "Actual 2025",
    projected2040: "Proyectado 2040",
    maintainLead: "Mantener liderazgo",
    strongGrowth: "Fuerte crecimiento",
    accelerating: "Acelerando",
    highestImprovement: "Mayor mejora",
    sourceFII: "Fuente: Plan Estratégico JCI Visión 2040 | Proyecciones del Índice de Inversión Futura 2024",
    
    // Simulator Section
    simulatorTitle: "Simulador de Escenarios Visión 2040",
    simulatorSubtitle: "Explore tres futuros posibles para JCI. ¿Qué sucede si superamos las expectativas—o nos quedamos cortos?",
    baseline2025: "Línea Base 2025",
    conservative: "Conservador",
    conservativeDesc: "¿Y si el crecimiento se estanca? Adopción tecnológica limitada, asociaciones mínimas, vientos económicos en contra.",
    moderate: "Moderado (Meta)",
    moderateDesc: "Trayectoria de crecimiento planificada con adopción digital esperada y asociaciones estratégicas.",
    aggressive: "Agresivo",
    aggressiveDesc: "Crecimiento máximo con adopción tecnológica completa, asociaciones extensas y expansión viral.",
    probability: "Probabilidad",
    scenarioOutcomes: "Resultados del Escenario",
    vsTarget: "vs meta",
    onTarget: "En Meta",
    keySuccessFactors: "Factores Clave de Éxito",
    risksAndChallenges: "Riesgos y Desafíos",
    growthTrajectory: "Comparación de Trayectoria de Crecimiento",
    scenario: "Escenario",
    targetModerate: "Meta (Moderado)",
    comparisonSummary: "Resumen de Comparación de Escenarios",
    metric: "Métrica",
    baseline: "Línea Base",
    target2040: "Meta 2040",
    sourceSimulator: "Fuente: Plan Estratégico JCI Visión 2040 | Los escenarios son proyecciones ilustrativas",
    
    // Growth Visualization Section
    growthVisualization: "Visualización de Crecimiento",
    growthDesc: "Trayectoria de crecimiento estratégico desde la línea base 2025 hasta las metas 2040",
    growthVisualizationDesc: "Trayectoria de crecimiento estratégico desde la línea base 2025 hasta las metas 2040",
    progress: "Progreso",
    members: "Miembros",
    membersK: "Miembros (K)",
    targetK: "Meta (K)",
    countries: "Países",
    localOrganizations: "Organizaciones Locales",
    annualProjects: "Proyectos Anuales",
    annualBeneficiaries: "Beneficiarios Anuales",
    current: "Actual",
    target: "Meta",
    growth: "Crecimiento",
    cagr: "TCAC",
    cagrMembers: "~8-10% TCAC",
    nationsGrowth: "+86 naciones",
    expansionRegions: "África Subsahariana, Medio Oriente, Sudeste Asiático",
    moreGrassrootsHubs: "Más centros de base",
    projectOrgAverage: "~1 proyecto/org promedio",
    youthPopulation: "~1,2% de la población juvenil global",
    priority: { critical: "Crítico", high: "Alto", medium: "Medio", low: "Bajo" },
    globalPresence: "Presencia Global JCI",
    globalMembers: "Miembros Globales",
    activeCountries: "Países Activos",
    averageGrowth: "Crecimiento Promedio",
    regionalDistribution: "Distribución Regional",
    globalPerformance: "Desempeño Global",
    performanceComparison: "Comparación entre desempeño actual vs metas de Visión 2040",
    detailedAnalysis: "Análisis Regional Detallado",
    featuredCountries: "Países Destacados",
    achievements: "Logros",
    challenges: "Desafíos",
    mainInitiatives: "Principales Iniciativas",
    leadershipDevelopment: "Excelencia en Desarrollo de Liderazgo",
    technologyInnovation: "Tecnología e Innovación Digital",
    sustainabilityFocus: "Enfoque en Sostenibilidad e Impacto",
    globalNetworkGrowth: "Expansión de la Red Global",
    strategicPillars: "Pilares Estratégicos",
    strategicPillarsTitle: "4 Pilares Estratégicos para 2040",
    strategicPillarsSubtitle: "Enfoque integrado para transformar la oportunidad de los jóvenes globalmente",
    strategicPillarsDesc: "Nuestra hoja de ruta está construida sobre cuatro pilares interconectados que juntos transformarán la oportunidad de los jóvenes mundialmente",
    viewAllInitiatives: "Ver Todas las Iniciativas",
    allInitiatives: "Todas las Iniciativas",
    pillar1Title: "Salud Mental y Bienestar",
    pillar2Title: "Desarrollo de Fuerza Laboral y Habilidades",
    pillar3Title: "Emprendimiento e Innovación",
    pillar4Title: "Asociación Global y Escalabilidad",
    sustainability: "Sostenibilidad",
    equityInclusion: "Equidad e Inclusión",
    current2040Target: "Actual → Meta 2040",
    milestoneRoadmap: "Hoja de Ruta de Hitos",
    milestoneDesc: "Rastree nuestro viaje desde el estado actual hasta el logro de Visión 2040",
    currentState: "Estado Actual",
    currentStateDesc: "Nuestro punto de partida - 148.000 miembros en 114 países",
    midpointTarget: "Meta Intermedia",
    midpointTargetDesc: "Marca del medio - 300.000 miembros en 150 países",
    accelerationPhase: "Fase de Aceleración",
    accelerationPhaseDesc: "Escalado rápido - 400.000 miembros en 175 países",
    visionAchieved: "Visión Lograda",
    visionAchievedDesc: "Meta completa - 500.000 miembros en 200 países",
    inProgress: "En Progreso",
    upcoming: "Próximo",
    completed: "Completado",
    planned: "Planificado",
    orgs: "Orgs",
    projects: "Proyectos",
    beneficiaries: "Beneficiarios",
    keyInitiatives: "Iniciativas Clave",
    needed: "Necesario",
    growthRequired: "crecimiento requerido",
    sourceStrategicPlan: "Fuente: Plan Estratégico JCI Visión 2040",
    timelineTitle: "Línea de Tiempo Visión 2040",
    yearsRemaining: "Años Restantes",
    historicalProgress: "Progreso Histórico",
    jciFounded: "JCI Fundada",
    foundedDesc: "Junior Chamber International establecida en St. Louis, Missouri",
    globalExpansion: "Expansión Global",
    globalExpansionDesc: "Expansión a 100+ países mundialmente",
    foundationYear: "Año de Fundación",
    foundationYearDesc: "Transformación digital y escalado del programa RISE",
    programs: "Programas",
    implementationProgress: "Progreso de Implementación",
    digitalPlatform: "Plataforma Digital",
    techTarget: "Meta: 80%+ de miembros usando plataforma digital para 2040",
    aiIntegration: "Integración de IA",
    aiDesc: "Experiencia de miembro personalizada y recomendaciones de programa",
    vrTraining: "Capacitación de Liderazgo VR",
    vrTrainingDesc: "Simulaciones inmersivas para desarrollo de liderazgo",
    aiDashboard: "Panel con IA",
    aiDashboardDesc: "Experiencia personalizada del miembro con recomendaciones de IA",
    sustainabilityGoals: "Objetivos de Sostenibilidad",
    carbonNeutral: "Operaciones Carbon Neutral",
    carbonNeutralDesc: "100% compensación de carbono para 2030",
    sdgAlignment: "Alineación ODS",
    sdgDesc: "Todos los programas mapeados a Objetivos de Desarrollo Sostenible de la ONU",
    techRoadmap: "Hoja de Ruta Tecnológica",
    techRoadmapDesc: "Hitos de transformación digital en nuestro camino hacia 2040",
    mobileApp: "Aplicación Móvil",
    mobileAppDesc: "Experiencia móvil offline-first para todos los miembros",
    sustainabilityTracking: "Seguimiento de Sostenibilidad",
    sustainabilityTrackingDesc: "Monitoreo de impacto ambiental en tiempo real",
    complete: "Completo"
  },
  vision2040Extended: {
    fiiImpactTab: "Impacto FII",
    timeline: "Línea de Tiempo",
    simulator: "Simulador",
    globalView: "Visión Global",
    milestoneTitle: "Hoja de Ruta de Hitos hacia 2040",
    milestoneSubtitle: "Metas clave e indicadores de progreso en cuatro fases estratégicas",
    milestoneRoadmap: "Hoja de Ruta de Hitos",
    milestoneRoadmapDesc: "Rastree nuestro viaje desde el estado actual hasta el logro de Visión 2040",
    currentState: "Estado Actual",
    currentStateDesc: "Nuestro punto de partida - 175.000 miembros en 115 países",
    midpointTarget: "Meta Intermedia",
    midpointTargetDesc: "Marca del medio - 300.000 miembros en 130 países",
    accelerationPhase: "Fase de Aceleración",
    accelerationPhaseDesc: "Escalado rápido - 400.000 miembros en 140 países",
    visionAchieved: "Visión Lograda",
    visionAchievedDesc: "Meta completa - 500.000 miembros en 150 países",
    inProgress: "En Progreso",
    upcoming: "Próximo",
    completed: "Completado",
    planned: "Planificado",
    target: "Meta",
    members: "Miembros",
    countries: "Países",
    localOrganizations: "Organizaciones Locales",
    orgs: "Orgs",
    projects: "Proyectos",
    beneficiaries: "Beneficiarios",
    keyInitiatives: "Iniciativas Clave",
    current: "Actual",
    needed: "Necesario",
    growthRequired: "crecimiento requerido",
    sourceStrategicPlan: "Fuente: Plan Estratégico JCI Visión 2040",
    fiiImpactTitle: "Impacto FII para 2040",
    fiiImpactDesc: "Mejoras proyectadas del Índice de Inversión Futura si JCI ejecuta la estrategia Visión 2040",
    globalFIIPoints: "Puntos FII Globales",
    africaMeFII: "Puntos FII África/MO",
    inequalityReduction: "Reducción de Desigualdad",
    regionalGapClosure: "Cierre de brecha regional",
    highest: "más alto",
    mentalHealthPillar: "Salud Mental",
    workforceDevelopment: "Desarrollo de Fuerza Laboral",
    entrepreneurshipPillar: "Emprendimiento",
    projectedReach: "Alcance Proyectado",
    fiiImpactLabel: "Impacto FII",
    primaryFocus: "Enfoque primario",
    regionalFIIProjectionsTitle: "Proyecciones FII Regionales: 2025 vs 2040",
    current2025: "Actual 2025",
    projected2040: "Proyectado 2040",
    maintainLead: "Mantener liderazgo",
    strongGrowth: "Fuerte crecimiento",
    accelerating: "Acelerando",
    highestImprovement: "Mayor mejora",
    sourceFII: "Fuente: Plan Estratégico JCI Visión 2040 | Proyecciones del Índice de Inversión Futura 2024",
    timelineTitle: "Línea de Tiempo Visión 2040",
    timelineDesc: "Contexto histórico y hitos futuros en nuestro viaje hacia 2040",
    yearsRemaining: "Años Restantes",
    historicalProgress: "Progreso Histórico",
    jciFounded: "JCI Fundada",
    foundedDesc: "Junior Chamber International establecida",
    globalExpansion: "Expansión Global",
    globalExpansionDesc: "Expansión a 100+ países mundialmente",
    foundationYearDesc: "Transformación digital y escalado del programa RISE",
    programs: "Programas",
    implementationProgress: "Progreso de Implementación",
    simulatorTitle: "Simulador de Escenarios Visión 2040",
    simulatorSubtitle: "Explore tres futuros posibles para JCI. ¿Qué sucede si superamos las expectativas—o nos quedamos cortos?",
    baseline2025: "Línea Base 2025",
    conservative: "Conservador",
    conservativeDesc: "¿Y si el crecimiento se estanca? Adopción tecnológica limitada, asociaciones mínimas, vientos económicos en contra.",
    moderate: "Moderado (Meta)",
    moderateDesc: "Trayectoria de crecimiento planificada con adopción digital esperada y asociaciones estratégicas.",
    aggressive: "Agresivo",
    aggressiveDesc: "Crecimiento máximo con adopción tecnológica completa, asociaciones extensas y expansión viral.",
    probability: "Probabilidad",
    scenarioOutcomes: "Resultados del Escenario",
    annualProjects: "Proyectos Anuales",
    vsTarget: "vs meta",
    onTarget: "En Meta",
    keySuccessFactors: "Factores Clave de Éxito",
    risksAndChallenges: "Riesgos y Desafíos",
    growthTrajectory: "Comparación de Trayectoria de Crecimiento",
    scenario: "Escenario",
    targetModerate: "Meta (Moderado)",
    comparisonSummary: "Resumen de Comparación de Escenarios",
    metric: "Métrica",
    baseline: "Línea Base",
    target2040: "Meta 2040",
    sourceSimulator: "Fuente: Plan Estratégico JCI Visión 2040 | Los escenarios son proyecciones ilustrativas para fines de planificación estratégica",
    simulatorData: {
      factors: {
        conservativeGrowth: "Crecimiento anual de 2-3% de miembros",
        limitedDigital: "Adopción limitada de plataforma digital",
        minimalPartnerships: "Mínimas nuevas asociaciones corporativas",
        moderateGrowth: "Crecimiento anual de 5-7% de miembros",
        fullDigital: "Implementación completa de plataforma digital",
        strategicPartnerships: "Asociaciones corporativas estratégicas",
        aggressiveGrowth: "Crecimiento anual de 10-15% de miembros",
        aiEngagement: "Engagement de miembros con IA",
        youthMovement: "Expansión viral del movimiento juvenil"
      },
      risks: {
        targetsMissed: "Las metas de Visión 2040 pueden no alcanzarse",
        reducedInfluence: "Influencia y alcance global reducidos",
        talentGaps: "Brechas de talento en regiones desatendidas",
        moderateRisk: "Riesgo moderado de ejecución permanece",
        resourceConstraints: "Restricciones de recursos posibles",
        competitionRisk: "Competencia de otras organizaciones",
        executionChallenges: "Desafíos significativos de ejecución",
        fundingRequirements: "Altos requisitos de financiamiento",
        marketChanges: "Las condiciones del mercado pueden cambiar"
      }
    },
    globalPresenceTitle: "Presencia Global JCI",
    globalMembers: "Miembros Globales",
    activeCountries: "Países Activos",
    averageGrowth: "Crecimiento Promedio",
    regionalDistribution: "Distribución Regional",
    globalPerformance: "Desempeño Global",
    performanceComparison: "Comparación entre desempeño actual vs metas de Visión 2040",
    detailedAnalysis: "Análisis Regional Detallado",
    achievements: "Logros",
    challenges: "Desafíos",
    growth: "Crecimiento",
    priority: { critical: "Crítico", high: "Alto", medium: "Medio", low: "Bajo" },
    milestoneInitiatives: {
      year2025: { initiative1: "Expansión de Plataforma Digital", initiative2: "Continuación del programa RISE", initiative3: "Línea base FII establecida", initiative4: "Estrategias de crecimiento regional" },
      year2030: { initiative1: "Operaciones carbon-neutral", initiative2: "Panel de miembros con IA", initiative3: "50% paridad de género alcanzada", initiative4: "LMS digital completamente implementado" },
      year2035: { initiative1: "10.000+ entrenadores certificados", initiative2: "Capacitación de liderazgo VR implementada", initiative3: "Brecha FII África/MO 50% cerrada", initiative4: "App móvil 300K+ descargas" },
      year2040: { initiative1: "Red de 500K jóvenes líderes", initiative2: "FII global mejoró 4-7 puntos", initiative3: "80%+ adopción de plataforma digital", initiative4: "Oportunidad de los jóvenes transformada" }
    },
    pillarData: {
      mentalHealth: { current: "145 proyectos RISE", projection: "5.000+ proyectos RISE", reach: "50M+ alcanzados", fiiImpact: "+2-3 puntos", focus: "Brecha de salud mental África/MO" },
      workforce: { current: "~50K capacitados", projection: "200K+ jóvenes capacitados", reach: "80% tasa de empleo", fiiImpact: "+1-2 puntos", focus: "Trayectorias STEM/digitales" },
      entrepreneurship: { current: "1K emprendedores", projection: "50K+ apoyados", reach: "$500M+ capital movilizado", fiiImpact: "+1-2 puntos", focus: "100K+ capacitados" }
    },
    regionNames: { europe: "Europa", asiaPacific: "Asia y el Pacífico", americas: "América", africaME: "África y Oriente Medio" },
    radarSubjects: { leadership: "Liderazgo", technology: "Tecnología", sustainability: "Sostenibilidad", partnerships: "Asociaciones", innovation: "Innovación", impact: "Impacto" },
    globalRegions: {
      americas: { name: "América", achievements: ["8,0% de la membresía global", "Fuerte red LO"], challenges: ["Retención de miembros", "Diversidad regional"] },
      europe: { name: "Europa", achievements: ["11,1% de la membresía global", "Liderazgo en sostenibilidad"], challenges: ["Demografía envejecida", "Estancamiento de crecimiento"] },
      asiaPacific: { name: "Asia y el Pacífico", achievements: ["70,7% de la membresía global", "Mayor potencial de crecimiento"], challenges: ["Barreras culturales", "Infraestructura digital"] },
      africaME: { name: "África y Medio Oriente", achievements: ["10,3% de la membresía", "Ventaja poblacional joven"], challenges: ["Recursos limitados", "Brechas de conectividad"] }
    }
  }
} as const;
